import type { Experiments } from '@wix/yoshi-flow-editor';
import React from 'react';
import { ActionsMenuLayout } from 'wix-ui-tpa/cssVars';
import {
  ActionButtonUiTypes,
  ActionMenuConfiguration,
  ActionsMenuType,
  BookingsGroup,
  OnActionClickType,
  RescheduleButtonOrigin,
} from '../../../../types';
import {
  hasSubmission,
  isBookAnotherAble,
  isCancelAble,
  isRescheduleAble,
} from '../../../../utils/bookInfo';
import { BookAgain } from '../ActionsButtons/BookAgain';
import { Cancel } from '../ActionsButtons/Cancel';
import { Reschedule } from '../ActionsButtons/Reschedule';
import { ReviewFormSubmission } from '../ActionsButtons/ReviewFormSubmission';
import { ActionsMenuDataHooks } from '../datahooks';
import { classes } from './ManageButton.st.css';

export const getMenuActionsConfiguration = (
  group: BookingsGroup,
  onActionClick: OnActionClickType,
  experiments: Experiments,
  shouldShowFormSubmission?: boolean,
): ActionMenuConfiguration[] | null => {
  const upperActions: ActionMenuConfiguration[] = [];
  const bottomActions: ActionMenuConfiguration[] = [];

  if (isBookAnotherAble(group)) {
    upperActions.push({
      type: ActionsMenuType.BOOK_AGAIN,
      Component: (
        <BookAgain
          group={group}
          type={ActionButtonUiTypes.MENU}
          onActionClick={onActionClick}
        />
      ),
    });
  }

  if (isRescheduleAble(group, experiments)) {
    upperActions.push({
      type: ActionsMenuType.RESCHEDULE,
      Component: (
        <Reschedule
          origin={RescheduleButtonOrigin.ActionMenu}
          group={group}
          type={ActionButtonUiTypes.MENU}
          onActionClick={onActionClick}
        />
      ),
    });
  }

  if (shouldShowFormSubmission && hasSubmission(group)) {
    upperActions.push({
      type: ActionsMenuType.REVIEW_FORM_SUBMISSION,
      Component: (
        <ReviewFormSubmission
          type={ActionButtonUiTypes.MENU}
          group={group}
          onActionClick={onActionClick}
        />
      ),
    });
  }

  if (isCancelAble(group)) {
    if (upperActions.length) {
      bottomActions.push({
        type: ActionsMenuType.DIVIDER,
        Component: (
          <ActionsMenuLayout
            data-hook={ActionsMenuDataHooks.ManageActionMenuDivider}
            className={classes.actionMenuLayout}
          >
            <ActionsMenuLayout.Divider />
          </ActionsMenuLayout>
        ),
      });
    }

    bottomActions.push({
      type: ActionsMenuType.CANCEL,
      Component: (
        <Cancel
          group={group}
          type={ActionButtonUiTypes.MENU}
          onActionClick={onActionClick}
        />
      ),
    });
  }

  if (!upperActions.length && !bottomActions.length) {
    return null;
  }

  return [...upperActions, ...bottomActions];
};
